const REIMBURSEMENT_CURRENCY_SYMBOLS = {
  USD: "$",
  CAD: "C$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
};

export function getReimbursementCurrencySymbol(currencyType) {
  const normalizedType =
    typeof currencyType === "string" ? currencyType.trim().toUpperCase() : "";
  return REIMBURSEMENT_CURRENCY_SYMBOLS[normalizedType] || "";
}
